import React from 'react';
import Footer from '../Footer';
import {
  LegalNav,
  LegalNavInner,
  LegalNavLogo,
  LegalLogoDot,
  LegalNavLinks,
  LegalNavLink,
  LegalMain,
  LegalContainer,
} from './LegalElements';

const LegalLayout = ({ children }) => {
  return (
    <>
      <LegalNav>
        <LegalNavInner>
          <LegalNavLogo to='/'>
            Cloutch
            <LegalLogoDot />
          </LegalNavLogo>
          <LegalNavLinks>
            <LegalNavLink to='/'>Home</LegalNavLink>
            <LegalNavLink to='/privacy'>Privacy</LegalNavLink>
            <LegalNavLink to='/terms'>Terms</LegalNavLink>
          </LegalNavLinks>
        </LegalNavInner>
      </LegalNav>
      <LegalMain>
        <LegalContainer>{children}</LegalContainer>
      </LegalMain>
      <Footer scrollLinks={false} />
    </>
  );
};

export default LegalLayout;
